import { useMemo } from 'react';
import { useAuthStore } from '../../store/authStore';
import { useMunicipalConfig, useMunicipalMidias } from './hooks/useMunicipalConfig';
import { useMunicipalComunicados } from './hooks/useMunicipalComunicados';
import { TvSignagePlayerCore } from '../../components/comunicados/TvSignagePlayerCore';
import type { ComunicadoItem } from '../../components/comunicados/ComunicadosConfig';

export default function TvGradeMunicipal() {
  const { user } = useAuthStore();
  const { config: muniConfig } = useMunicipalConfig();
  const municipioId = user?.municipioId || '';

  const config = useMemo(
    () => ({
      scope: 'MUNICIPAL',
      scopeId: municipioId,
      branding: {
        tenantName:
          muniConfig?.nomeOficial ||
          (muniConfig?.nome ? `Prefeitura Municipal de ${muniConfig.nome}` : 'Prefeitura Municipal'),
        tenantBadge: muniConfig?.nomeSecretario
          ? `Secretaria de Educação — ${muniConfig.nomeSecretario}`
          : 'Secretaria Municipal de Educação',
        logoUrl: muniConfig?.logoUrl,
        primaryColor: muniConfig?.corPrimaria || '#1e3a8a',
        secondaryColor: muniConfig?.corSecundaria || '#059669',
        slogan: muniConfig?.slogan,
        autoridadeNome: muniConfig?.nomePrefeito,
        autoridadeCargo: muniConfig?.cargoPrefeito || 'Prefeito Municipal',
      },
    }),
    [municipioId, muniConfig]
  );

  const { data: comunicados = [], isLoading: l1 } = useMunicipalComunicados();
  const { midias = [], isLoading: l2 } = useMunicipalMidias();

  return (
    <TvSignagePlayerCore
      config={config}
      comunicados={comunicados as unknown as ComunicadoItem[]}
      midias={midias}
      isLoading={l1 || l2}
    />
  );
}
